export default "__VITE_ASSET__9bca41d7__"